import { User } from "lucide-react";
import styled from "styled-components";
import { Dialog } from "@/components/ui/dialog";
import { DialogPerfil } from "@/components/dialogs/profile";
import { useState } from "react";

export function MainHeader() {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<Header>
			<h1 className="text-2xl font-bold">Control de Huella de Carbono</h1>
			<div className="flex-1"></div>
			<div className="flex items-center p-2 user-profile" onClick={() => setIsOpen(true)}>
				<User />
			</div>
			<Dialog open={isOpen} onOpenChange={setIsOpen}>
				<DialogPerfil onSuccess={() => setIsOpen(false)} />
			</Dialog>
		</Header>
	);
}

const Header = styled.header`
	flex: 1;
	display: flex;
	justify-content: space-between;
	align-items: center;
	background-color: #282c34;
	color: white;
	height: var(--header-height);
	padding-left: 5px;

	h1 {
		margin: 0 0 0 24px;
	}
`;
